module.exports = __webpack_public_path__ + "img/mistake.438bf718.svg";